import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';
import { TruckDriversSearchCriteria } from '../models';
import { MatDialogRef } from '@angular/material/dialog';

export class TruckDriversLoad {
  public static readonly type = '[TruckDrivers] Load';

  constructor(public payload: TruckDriversSearchCriteria) {}
}

export class TruckDriversInitialState {
  public static readonly type = '[TruckDrivers] Set initial state';
}

export class TruckDriverItemDelete {
  public static readonly type = '[TruckDrivers] Delete';

  constructor(
    public payload: {
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      frequentDriverIds: number[];
      truckIds: number[];
      tourExecutionIds: number[];
    },
  ) {}
}
